<template>
  <section class="app-aproc">
    <v-container
      v-scroll="onScroll"
      v-resize="onResize"
      grid-list-xl
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          lg12
          sm12
          xs12
        >
          <v-card
            outlined
            class="app-card"
          >
            <v-card-title
              class="app-card-title"
            >
              Consultar Processos entre 2021 e 2023
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-alert
                outlined
                type="info"
                text
                class="mb-0"
              >
                Digite o "Número de VIPROC" para pesquisar por processos
                gerados entre 2021 e 2023. Basta digitar o número completo do
                VIPROC (com zero à esquerda quando houver).
              </v-alert>
              <br>
              <v-form
                ref="form"
                v-model="formModel.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col
                    :md="9"
                    :sm="9"
                    :xs="12"
                    cols="12"
                    class="pb-0"
                  >
                    <v-text-field
                      ref="viproc"
                      v-model="formModel.viproc"
                      type="text"
                      label="Número de Viproc *"
                      placeholder="Ex.: 0000000000/2021"
                      :rules="[rules.required, rules.pattern]"
                      filled
                      rounded
                      dense
                    />
                  </v-col>
                  <v-col
                    :md="3"
                    :sm="3"
                    :xs="3"
                    cols="12"
                  >
                    <v-btn
                      depressed
                      block
                      large
                      color="primary"
                      type="submit"
                    >
                      Pesquisar
                    </v-btn>
                  </v-col>
                  <v-col
                    :md="9"
                    :sm="9"
                    :xs="9"
                    cols="12"
                    class="pb-0"
                  >
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :load-recaptcha-script="true"
                      class="recaptcha"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                    />
                    <v-input
                      v-model="formModel.recaptcha"
                      :rules="[rules.required]"
                      style="margin-top: -25px"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
          <div
            v-if="isLoading"
            class="text-xs-center area-loading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="20"
              :width="2"
            />
            <span class="text-loading">Buscando ...</span>
          </div>
        </v-flex>

        <div id="area-processo" />

        <v-flex
          id="card-processo"
          lg12
          sm12
          xs12
          transition="fade-transition"
        >
          <v-card
            v-if="processo"
            outlined
            class="app-card"
          >
            <v-card-title
              class="app-card-title"
            >
              Detalhes do Processo
            </v-card-title>

            <v-card-text class="mt-10">
              <v-layout
                row
                wrap
              >
                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Viproc N°"
                    :value="processo.identificadorViproc"
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Relator"
                    :value="
                      processo.relator ? processo.relator : 'NÃO HÁ RELATOR'
                    "
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Situação"
                    :value="processo.status"
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Espécie"
                    :value="processo.especieProcesso.nome"
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Data de Criação"
                    :value="processo.dataCriacao"
                    type="date"
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Setor Origem"
                    :value="
                      processo.setorOrigem.sigla +
                        '-' +
                        processo.setorOrigem.nome
                    "
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg6
                  sm6
                  xs12
                >
                  <v-text-field
                    label="Assunto"
                    :value="processo.assunto"
                    readonly
                  />
                </v-flex>

                <v-flex
                  lg12
                  sm12
                  xs12
                >
                  <v-textarea
                    outline
                    label="Descrição"
                    :value="processo.descricao"
                    readonly
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          v-if="tramitacoes && tramitacoes.length > 0"
          lg12
          sm12
          xs12
          transition="fade-transition"
        >
          <v-card
            outlined
            class="app-card"
          >
            <v-card-title
              class="app-card-title"
            >
              Histórico de Tramitações
            </v-card-title>

            <v-card-text id="card-text">
              <v-timeline
                align-top
                :dense="modeTimeline"
              >
                <v-timeline-item
                  v-for="(tramitacao, key) in tramitacoes"
                  :key="key"
                  :color="key === 0 ? '#1976d2' : '#e0e0e0'"
                  small
                >
                  <v-card
                    :color="key === 0 ? '#1976d2' : '#e0e0e0'"
                    dark
                    outlined
                  >
                    <v-card-title
                      class="title title-card"
                      :class="key === 0 ? 'title-card--first' : ''"
                    >
                      {{ changeStatusTramitacao(key, tramitacao.status) }}
                    </v-card-title>
                    <v-card-text class="white text--primary">
                      <div>
                        <span>
                          <strong>Motivo:</strong>
                          {{ tramitacao.motivo }}.
                        </span>
                      </div>

                      <div>
                        <span>
                          <strong>Setor Origem:</strong>
                          {{ tramitacao.setorOrigem.sigla }} -
                          {{ tramitacao.setorOrigem.nome }} -
                          {{ tramitacao.dtDespacho | formatDate("LLL") }}.
                        </span>
                      </div>

                      <div>
                        <span>
                          <strong>Setor Destino:</strong>
                          {{ tramitacao.setorDestino.sigla }} -
                          {{ tramitacao.setorDestino.nome }} -
                          {{ tramitacao.dtRecebimento | formatDate("LLL") }}.
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>

              <div class="text-xs-center">
                <v-progress-circular
                  v-if="loadingTramitations"
                  indeterminate
                  color="primary"
                  class="loading-tramitacoes"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ProcessoService from "@/services/processo-eletronico/processo.service";
import TramitacaoService from "@/services/processo-eletronico/tramitacao.service";

import { mask } from "vue-the-mask";
import { delay } from "rxjs/operators";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import GlobalStore from "@/store/modules/global";

export default Vue.extend({
  components: {
    VueRecaptcha,
  },
  directives: {
    mask,
  },
  metaInfo: {
    title: "Consulta de Processos - Central de Serviços",
  },
  filters: {
    formatDate: (dateToFormat, pattern) => moment(dateToFormat).format(pattern),
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    loadingTramitations: false,
    formModel: {
      valid: false,
      recaptcha: null,
      viproc: "",
    },
    processo: null,
    tramitacoes: [],
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      pattern: (value) =>
        !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
        "Esse campo está fora do padrão",
    },
    page: 1,
    size: 15,
    endTramitations: false,
    error: "",
    urlLogo: "img/logo-arce.png",
    modeTimeline: false,
    items: [{ key: "viproc", text: "Viproc" }],
  }),
  mounted() {
    moment.locale("pt-br");
    this.verifyWidth(window.innerWidth);
    //this.initData();
  },
  methods: {
    clearFieldNumber() {
      this.formModel.viproc = null;
    },
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
      this.initData();
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    initData() {
      const { query } = this.$route;
      if (query && query.numero) {
        this.formModel.viproc = query.numero;
        this.onSubmit();
      }
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.endTramitations = false;
        this.page = 1;
        this.tramitacoes = [];
        this.loadData();
      }
    },
    loadData() {
      this.isLoading = true;
      const recaptcha = this.formModel.recaptcha;

      ProcessoService.findByViproc(this.formModel.viproc, recaptcha).subscribe(
        (response) => {
          this.processo = response;
          this.isLoading = false;
          this.expiredRecaptcha();
          this.scrollToProcesso();
          this.loadTramitacoes();
        },
        (error) => {
          this.expiredRecaptcha();
          this.processo = null;
          this.isLoading = false;
        }
      );
    },
    loadTramitacoes() {
      TramitacaoService.findByProcessoId(
        this.processo.id,
        this.page,
        this.size
      ).subscribe(
        (response) => {
          if (this.processo) {
            this.tramitacoes = response;
          }
          this.isLoading = false;
          if (this.tramitacoes.length === 0) {
            let message = "Não existem movimentações para esse processo.";
            GlobalStore.setSnackBar({ show: true, type: "error", message });
          }
        },
        (error) => {
          this.expiredRecaptcha();
          this.tramitacoes = [];
          this.isLoading = false;
        }
      );
    },
    clear() {
      this.processo = null;
      this.tramitacoes = [];
      this.formModel.viproc = "";
    },
    onScroll() {
      const { documentElement } = document;
      let bottomOfWindow =
        documentElement.scrollTop + window.innerHeight ===
        documentElement.offsetHeight;

      if (
        bottomOfWindow &&
        !this.endTramitations &&
        this.tramitacoes &&
        this.processo
      ) {
        this.page += 1;
        this.loadingTramitations = true;
        TramitacaoService.findByProcessoId(
          this.processo.id,
          this.page,
          this.size
        )
          .pipe(delay(1000))
          .subscribe(
            (tramitacoes) => {
              if (tramitacoes.length > 0) {
                this.tramitacoes.push(...tramitacoes);
              } else {
                this.endTramitations = true;
              }
            },
            (error) => {
              this.tramitacoes = [];
              throw error;
            },
            () => {
              this.loadingTramitations = false;
            }
          );
      }
    },
    onResize() {
      this.verifyWidth(window.innerWidth);
    },
    verifyWidth(size) {
      this.modeTimeline = size <= 767;
    },
    changeStatusTramitacao(key, status) {
      if (key === 0 && this.processo && this.processo.dataEncerramento) {
        return "FINALIZADO";
      } else if (key === 0) {
        return "RECEBIDO (FASE ATUAL)";
      } else {
        return status;
      }
    },
    scrollToProcesso() {
      this.$vuetify.goTo("#card-processo");
    },
  },
});
</script>

<style lang="scss">
input {
  text-transform: uppercase;
}
.area-loading {
  text-align: center;
  margin: 10px;
  .v-progress-circular {
    margin-right: 10px;
  }
}
.loading-tramitacoes {
  margin: auto;
  display: table;
}
.v-alert__content {
  font-weight: 500;
}
</style>
